import OperationsRepository from '@/libs/customAxios/operationAxios'

const authTokenSettingResource = '/admin/settings/auth-token'

export default {
  getAuthTokenSetting() {
    return OperationsRepository.get(authTokenSettingResource)
  },
  updateAuthTokenSetting(payload) {
    return OperationsRepository.put(authTokenSettingResource, payload)
  },
}
